// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import { fuzzysearch } from '../../../../utils/fuzzysearch';

type Props = {
  selectSources: { label: string, id: number | string, selected?: boolean }[],
  handleChange: Function,
  placeholder: string,
  alwaysDisplayOptions: ?boolean,
  side?: 'left' | 'right' | 'bottom' | 'top',
  sort: ?boolean,
};

type State = {
  searchWord: string,
  isFocused: boolean,
};

class SearchSelect extends React.Component<Props, State> {
  static defaultProps = {
    alwaysDisplayOptions: false,
    side: 'bottom',
    sort: true,
  };
  state = {
    searchWord: '',
    isFocused: false,
  };

  handleChange = (event: EventHandler) => {
    this.setState({
      searchWord: event.target.value,
    });
  };

  render() {
    const selectOptions = (this.props.selectSources || []).filter((value) => {
      if (this.state.searchWord !== '' && value) {
        return fuzzysearch(this.state.searchWord, value.label);
      }
      return true;
    });

    return (
      <div
        role="presentation"
        className={`select-array-container ${this.props.side || 'bottom'}`}
        onFocus={() => this.setState({ isFocused: true })}
        onBlur={(e) => {
          if (!e.currentTarget.contains(e.relatedTarget) || e.relatedTarget === null) {
            this.setState({ isFocused: false });
          }
        }}
      >
        <div className="search-input">
          <input
            type="search"
            onChange={this.handleChange}
            placeholder={this.props.placeholder}
          />
        </div>
        {
          (this.props.alwaysDisplayOptions || this.state.isFocused)
          && (
            <div
              role="presentation"
              className="select-array"
            >
              {
                selectOptions.length > 0
                  ? (selectOptions
                    .sort((a, b) => (this.props.sort ? a.label.localeCompare(b.label) : 0))
                      .map(value => (
                        <button
                          className={`search-filter${value.selected ? ' active' : ''}`}
                          key={value.id}
                          onClick={() => this.props.handleChange(value.id)}
                        >
                          <p>{value.label}</p>
                        </button>
                      ))
                  ) : (
                    <button className="search-filter">
                      <i>{I18n.t('comparator.noPropositions')}</i>
                    </button>
                  )
              }
            </div>
          )
        }
      </div>
    );
  }
}

export default SearchSelect;
